import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import StarButton from './StarButton';
import Loader from './Loader';

const ListingStep20 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const navigate = useNavigate();
  const [listingData, setListingData] = useState([]);
  const [paymentOptionList, setPaymentOptionList] = useState([]);
  const [paymentOption, setPaymentOption] = useState(2);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setPaymentOption(listingData.payment_option !== null ? listingData.payment_option : 2);
          setPaymentOptionList(listingData.payment_option_list);
          setQuestion(response.data.updated_property_item.questions);

          setLoading(false);
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.error(err.message);
        toast.error('Failed to load listing data.');
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchListingData();
  }, [listingId]);

  
    const saveListing = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      const ts = Date.now();

      const updatedPropertyItem = {
          payment_option: paymentOption,
      };

      const mergedData = { ...listingData, ...updatedPropertyItem };

      let catData = new FormData();
      catData.append('token', hostData.host_access_token);
      catData.append('listing_id', listingId);
      catData.append('data', JSON.stringify(mergedData));
      catData.append('ts', ts);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: `${params.baseURL}${params.endpoints.updateListing}`,
          data: catData,
        });

        if (response.data.status === 'done') {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        toast.error('An error occurred while saving the listing');
        return false;
      }
    };

   

  const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-19' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>

      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 19)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
              <div>
                <h4 className='ws-title'>Payment Option</h4>
              </div>
            </div>

          <div className='st1-desc-box'>
            <div className='ws-row'>
              <div className='col-md-12'>
                <div className="room-detail-box">
                <div>
                    <p className="rdb-title mb-0">Choose Your Payment Preference</p>
                </div>
                <div className="row">
                    <div className="col-md-12 custom-radio-box" style={{ display: 'block', border: 'none' }}>
                    {paymentOptionList.length > 0 ? (
                        paymentOptionList.map((list) => (
                        <div key={list.id} className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="paymentOption"
                                id={`paymentOption-${list.id}`}
                                value={list.id}
                                checked={paymentOption === list.id}
                                onChange={() => setPaymentOption(list.id)}
                            />
                            <label className="form-check-label" htmlFor={`paymentOption-${list.id}`}>
                                {list.title}
                            </label>
                        </div>
                        ))
                    ) : (
                        <div className="dropdown-item">No options found</div>
                    )}
                    </div>
                </div>
                <p className='label-hint'>Please select your preferred payment method carefully. If you choose 'Pay at Property,' you will receive payment directly from the guest upon check-in. If you select 'Pay via Wire Stay,' the payment will be processed securely through Wire Stay's gateway and credited to your account. Ensure your choice aligns with your operational preferences.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
              <div className='blog-box'>
                  <div class="blog">
                      <div class="blog-image">
                          <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                          <div class="date">May 08, 2025</div>
                      </div>
                      <div class="blog-content">
                          <h2>What is Lorem Ipsum?</h2>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                          <a href="#">Read More</a>
                      </div>
                  </div>
              </div>
              <div className="faq-sticky">
                  {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                      <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                          backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                      >
                      {faq.question}
                      <i
                          className={`fas ${
                          activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                          style={{
                          transition: "transform 0.3s ease",
                          }}
                      ></i>
                      </div>
                      {activeIndex === index && (
                      <div className='faqs-ans-box'>
                          {faq.answer}
                      </div>
                      )}
                  </div>
                  ))}
              </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingStep20;